import React from 'react';
import { styled } from '@mui/material';
import { useAppProps } from '../App';
import { MobileNavigation } from './navigation';


const Root = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
`;


const HeaderRoot = styled('div') <{ burl: string }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 120px;
  background-image: url(${props => props.burl});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  justify-content: space-between;

  @media (max-width: 800px) {
    height: 160px;
  }
  
  margin-bottom: 20px;
  @media (max-width: 1200px) {
    margin-bottom: 0;
  }
`;

const StyledLinkMain = styled('a')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 1 auto;
  overflow: hidden;

  > img {
    object-fit: contain;
    overflow: hidden;
    max-height: 100px;
  }

  @media (max-width: 600px) {
    flex: 1 1 100px;
  }
`;

const StyledLinkMainGrow = styled(StyledLinkMain)`
  text-decoration: none;
  padding: 0 20px;
`;

const DesktopBannerWideA = styled('a')`
  flex: 0 0 728px;
  padding: 10px;
  height: 90px;
  display: block;
  @media (max-width: 1200px) {
    display: none;
  }
`;

const DesktopBannerWide = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const DesktopBannerA = styled('a')`
margin: 20px 0;
  width: 728px;
  height: 90px;
  display: none;
  @media (max-width: 1200px) {
    display: block;
  }
  @media (max-width: 800px) {
    display: none;
  }
`;

const DesktopBanner = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const MobileBannerA = styled('a')`
    margin: 20px 0;
    height: 100px;
    width: 320px;
    display: none;
    @media (max-width: 800px) {
        display: block;
    }
`;

const MobileBanner = styled(DesktopBanner)`
  object-fit: contain;
`;

const HeaderText = styled('h1')`
    font-weight: normal;
    font-size: 24px;
    margin: 0;
    padding: 0;
    color: #fff;
    font-family: NotoSans, sans-serif;
`


export const Header: React.FC = () => {
  const { siteData: { headerBackground, mainSponsorBanner, mainSponsorMobileBanner } } = useAppProps();
  return <Root>
    <HeaderRoot burl={headerBackground}>
      <StyledLinkMainGrow href={'/'}>
        <HeaderText>
          <span>конкурс</span><br /><span style={{ fontSize: '28px', fontWeight: 'bold', textTransform: 'uppercase' }}>Лучшие российские часы</span>
        </HeaderText>
      </StyledLinkMainGrow>
      <DesktopBannerWideA href={mainSponsorBanner.link}>
        <DesktopBannerWide src={mainSponsorBanner.image} />
      </DesktopBannerWideA>
      <MobileNavigation />
    </HeaderRoot>
    <DesktopBannerA href={mainSponsorBanner.link}>
        <DesktopBanner src={mainSponsorBanner.image} />
    </DesktopBannerA>
    <MobileBannerA href={mainSponsorMobileBanner.link}>
        <MobileBanner src={mainSponsorMobileBanner.image} />
    </MobileBannerA>
  </Root>;
};